import styled from "styled-components";

export const ChartFilterButtonContainer = styled.div`
  padding-right: 15px;
`;
